import { EPaymentCreationType } from "./EPaymentCreationType";

/**
 * Payment creation types that receive the standard "PAYROLL" ACH description
 * (see getDescriptionForTransferType in odo) and align with worker bank payroll
 * credit flows for partner webhooks.
 */
export const PAYROLL_DESCRIPTION_PAYMENT_TYPES = new Set<EPaymentCreationType>([
  EPaymentCreationType.FASTER_PAY,
  EPaymentCreationType.ONE_DAY,
  EPaymentCreationType.PAY_EMPLOYEE,
  EPaymentCreationType.PREFUNDED_BATCH_DISBURSEMENT,
  EPaymentCreationType.PREFUNDED_EMPLOYEE_DISBURSEMENT,
]);

export const isPayrollDescriptionPaymentType = (
  type: EPaymentCreationType
): boolean => PAYROLL_DESCRIPTION_PAYMENT_TYPES.has(type);
